/**
 * SSE 流地址。
 *
 * ⚠️ 这条端点**不在 OpenAPI 里**（后端 `frames/router.py` 用
 * `include_in_schema=False`——SSE 是流端点、不是 JSON 资源）⇒ 故这里**不**把
 * 它挂进 `shared/api/wire.ts::EP`（那张表是「前端调用的活端点」清单，每条
 * 都要对得上 spec 的 operationId）。
 *
 * 鉴权走 HttpOnly cookie `steam_access`（后端 `frames/router.py::SSE_COOKIE_NAME`）
 * ⇒ `EventSource` 原生带 cookie ⇒ 前端零改造（ADR 0005 D2）。
 */
const SSE_STREAM_PATH = '/api/v1/notifications/stream';

export function eventStreamUrl(origin?: string): string {
  const base = origin ?? (typeof window === 'undefined' ? '' : window.location.origin);
  return `${base}${SSE_STREAM_PATH}`;
}
